interface UserMenuItemProps {
  href: string;
  text: string;
}

interface Props {
  hide?: boolean;
  userLinks?: UserMenuItemProps[];
  userName?: string;
  userTitle?: string;
}

const UnifiedMenu = ({ hide, userLinks, userName }: Props) => {
  const UserMenuItem = ({ href, text }: UserMenuItemProps) => (
    <a href={href} slot="user">
      <omnibar-user-menu-item
        // @ts-expect-error: children "does not exist on type"
        // eslint-disable-next-line react/no-children-prop
        children={text}
        menu-name={text}
      />
    </a>
  );

  return (
    <omnibar-unified-menu
      // @ts-expect-error: children and slot "does not exist on type"
      // eslint-disable-next-line react/no-children-prop
      children={
        userLinks &&
        userLinks.map((link) => (
          <UserMenuItem key={link.href} href={link.href} text={link.text} />
        ))
      }
      slot="unified-menu"
      style={hide ? { display: 'none' } : {}}
      user-name={userName}
      user-title={userName}
    />
  );
};

export default UnifiedMenu;
